import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { WallAddPage } from '../wall-add/wall-add';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import * as moment from "moment";
/**
 * Generated class for the WallPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-wall',
  templateUrl: 'wall.html',
})
export class WallPage {

  comment: any = {};
  itemId: number = -1;
  items: any = [];
  constructor(private alertCtrl: AlertController, private iab: InAppBrowser, public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {
    this.loadData();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WallPage');
  }

  loadData() {
    this.teamappProvider.http_request('action=get_items', 'wall', false, true).then(data => {
      this.items = data;
      console.log(data);
    });
  }

  like_item(item: any) {
    this.teamappProvider.http_request('action=like_item&wall_id='+item.id, 'wall', false, true).then(data => {
      item.like_count = item.like_count+1;
      item.like_state = 'has_liked';
    });
  }

  like_comment(item: any) {
    this.teamappProvider.http_request('action=like_comment&comment_id='+item.id, 'wall', false, true).then(data => {
      item.like_count = item.like_count+1;
      item.like_state = 'has_liked';
    });
  }

  unlike_comment(item: any) {
    this.teamappProvider.http_request('action=unlike_comment&comment_id='+item.id, 'wall', false, true).then(data => {
      item.like_count = item.like_count-1;
      item.like_state = 'has_not_liked';
    });
  }

  unlike_item(item: any) {
    this.teamappProvider.http_request('action=unlike_item&wall_id='+item.id, 'wall', false, true).then(data => {
      item.like_count = item.like_count-1;
      item.like_state = 'has_not_liked';
    });
  }

  ionViewDidEnter() {
    this.loadData();
  }

  wallOption(item: any) {
    let alert = this.alertCtrl.create({
      title: 'Eintrag löschen',
      message: 'Den Eintrag löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Löschen',
          handler: () => {
            this.teamappProvider.http_request('action=remove_item&wall_id='+item.id, 'wall', false, true).then(data => {
              this.loadData();
            });
          }
        }
      ]
    });
    alert.present();
  }

  commentOption(item: any) {
    let alert = this.alertCtrl.create({
      title: 'Kommentar löschen',
      message: 'Den Kommentar wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Löschen',
          handler: () => {
            this.teamappProvider.http_request('action=remove_comment&comment_remove='+item.id, 'wall', false, true).then(data => {
              this.loadData();
            });
          }
        }
      ]
    });
    alert.present();
  }


  commentEnter(item:any) {
    this.teamappProvider.http_request('action=add_comment&wall_id='+item.id+'&comment_text='+this.comment[item.id], 'wall', false, true).then(data => {
      item.comments.push({
        name: this.userProvider.getUserName()+' '+this.userProvider.getUserSurname(),
        comment: this.comment[item.id],
        image: this.userProvider.getUserImage(),
        date: Date()
      });
      this.comment[item.id] = '';
    });
  }
  debug(item:any) {
    console.log(item);
  }
  subCommentEnter(item: any) {
    let alert = this.alertCtrl.create({
      title: 'Kommentieren',
      message: 'Antwort auf Kommentar: <br><br><b>'+item.comment+'</b>',
      inputs: [
        {
          name: 'comment',
          placeholder: 'Kommentar'
        },
      ],
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Absenden',
          handler: data => {
            let dataTmp: any = data;
            console.log(dataTmp);
            this.teamappProvider.http_request('action=add_sub_comment&comment_id='+item.id+'&comment_text='+dataTmp.comment, 'wall', false, true).then(data => {
              item.sub_comments.push({
                name: this.userProvider.getUserName()+' '+this.userProvider.getUserSurname(),
                comment: dataTmp.comment,
                image: this.userProvider.getUserImage(),
                date: Date()
              });
            });
          }
        }
      ]
    });
    alert.present();
  }

  openUrl(link:string) {
    this.iab.create(link, '_blank');
  }

  addToWall() {
    this.navCtrl.push(WallAddPage);
  }

  formatDate(date: any) {
    return moment(date).format("DD.MM.YYYY HH:mm");
  }

  formatDateNice(date: any) {
    return moment(date).fromNow();
  }
}



// WEBPACK FOOTER //
// ./src/pages/wall/wall.ts